import { SiteDetailPage } from '@/shared/site-detail/components/SiteDetailPage'

import { HodDetail } from './HodDetail'
import { IssueDetail } from './IssueDetail'

import type { GisScope, GisSite } from '../../../api/types'
import type { DetailFrame, HodOpenRef } from '../../../lib/detail-stack'

export interface DetailDrillHostProps {
  frame: DetailFrame
  backLabel: string
  sites: GisSite[]
  scope: GisScope
  onBack: () => void
  onOpenIssue: (id: string, siteId?: string | null) => void
  onOpenHod: (hod: HodOpenRef) => void
  onSelectOfficer: (id: string, name: string) => void
  onSelectMandal: (name: string) => void
}

/**
 * Renders the top drill frame's body (issue / site / HOD). Each body wraps itself in `DetailOverlay`
 * (`absolute inset-0`), so it fills whatever POSITIONED container hosts it — the full-mode right
 * drawer column (AnalyticsPanel's DetailDrawerRow), the site full pane, or the split-mode popup
 * card floating over the map (GisViewPage). Back buttons pop the drill stack via `onBack`.
 */
export function DetailDrillHost(p: DetailDrillHostProps) {
  const f = p.frame
  if (f.kind === 'issue') {
    return (
      <IssueDetail
        issueId={f.id}
        backLabel={p.backLabel}
        onBack={p.onBack}
        sites={p.sites}
        scope={p.scope}
        onOpenIssue={p.onOpenIssue}
        onOpenHod={p.onOpenHod}
        onSelectOfficer={p.onSelectOfficer}
        onSelectMandal={p.onSelectMandal}
      />
    )
  }
  if (f.kind === 'site') {
    // Site drill renders the shared entity site-view (view-only in GIS — no edit modal injected).
    // `absolute inset-0` fills the relative host so the page's own `h-full` + internal scroll
    // behave; px gives side gutters.
    return (
      <div className="absolute inset-0 overflow-hidden px-4">
        <SiteDetailPage siteId={f.siteId} onBack={p.onBack} />
      </div>
    )
  }
  return (
    <HodDetail
      department={f.department}
      hodName={f.hodName}
      hodPhone={f.hodPhone}
      hodEmail={f.hodEmail}
      scope={p.scope}
      sites={p.sites}
      backLabel={p.backLabel}
      onBack={p.onBack}
      onOpenHod={p.onOpenHod}
      onSelectOfficer={p.onSelectOfficer}
      onSelectMandal={p.onSelectMandal}
    />
  )
}
